__turbopack_context__.v({
  "sign_out": "UserMenu-module-scss-module__LhGTtq__sign_out",
  "user_menu": "UserMenu-module-scss-module__LhGTtq__user_menu",
  "user_menu_inner": "UserMenu-module-scss-module__LhGTtq__user_menu_inner",
});
